import { render, staticRenderFns } from "./ModifyPwd.vue?vue&type=template&id=6f409bb2&scoped=true&"
import script from "./ModifyPwd.vue?vue&type=script&lang=js&"
export * from "./ModifyPwd.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPwd.vue?vue&type=style&index=0&id=6f409bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f409bb2",
  null
  
)

export default component.exports